import { Model } from 'src/containers/ProjectDiagram/types/model';

export const setDataProperty =
  <Data extends go.ObjectData>(model: Model) =>
  <DataKey extends keyof Data & string>(
    data: Data,
    dataKey: DataKey,
    value: Data[Exclude<DataKey, ''>]
  ) =>
    model.setDataProperty(data, dataKey, value);
